<template>
  <div>
    <div class="filter-row">
      <label for="search">key</label>
      <input type="text" v-model="key" placeholder="請輸入要查詢的key" />
      <label for="search">操作者</label>
      <input type="text" v-model="updateUser" placeholder="請輸入要查詢的人" />
      <label for="search">動作</label>
      <select v-model="selected">
        <option v-for="option in options" :value="option" :key="option">{{ option }}</option>
      </select>
      <button @click="search">查詢</button>
    </div>
    <div class="history-content">
      <div class="header-row">
        <div class="header-type">動作</div>
        <div class="header-user">操作者</div>
        <div class="header-time">更新時間</div>
      </div>
      <v-collapse-group :onlyOneActive="false" >
        <v-collapse-wrapper
          v-for="(auditLog, index) in historyData"
          :key="`list-${auditLog._id}`"
        >
          <div class="header" v-collapse-toggle>
            <div class="collapse-row update-type">{{ convertChangeTypeToUpdateType(auditLog.changeType) }}</div>
            <div class="collapse-row update-user" @click="handleClickSelectAndCopy">{{ auditLog.operator }}</div>
            <div class="collapse-row timestamp">{{ dayjs(auditLog.createdAt).format('DD/MM/YYYY HH:mm:ss') }}</div>
          </div>
          <div class="my-content" v-collapse-content>
            <div class="collapse-child">
              <div v-if="auditLog.key" class="audit-log-key">Key: {{ `${auditLog.key}` }}</div>
              <div v-if="auditLog.reviewedVersion" style="margin-top: 5px;">
                審核版本：
                <span style="font-weight: bold;">{{ `${auditLog.reviewedVersion}` }}</span>
                <div style="margin-top: 10px;">審核單號：</div>
                <div v-for="(ticket) in auditLog.reviewedTickets" :key="ticket">
                  <a target="_blank" :href="'https://innotech.atlassian.net/browse/' + ticket">{{ ticket }}</a>
                </div>
              </div>
              <div v-if="auditLog.ticketUpdateVersion" style="margin-top: 5px;">修改版本: {{ `${auditLog.ticketUpdateVersion}` }}</div>
              <div v-if="auditLog.delta[0]">
                <div class="ticket">
                  <a target="_blank" :href="'https://innotech.atlassian.net/browse/' + auditLog.delta[0]['ticket']">{{ auditLog.delta[0]['ticket'] }}</a>
                </div>
                <div
                  v-for="detail in formatContent(auditLog, index)"
                  :key="`detail-${detail.id}`"
                >
                  <div v-if="detail.old" class="old">
                    {{ `${detail.old}` }}
                  </div>
                  <div v-if="detail.approve">
                    {{ `${detail.approve}` }}
                    <span style="font-weight: bold;">{{ `${detail.prevVer} → ${detail.currVer}` }}</span>
                  </div>
                  <div v-if="detail.updateTicket">
                    {{ `${detail.updateTicket}` }}
                    <span style="font-weight: bold;">
                      <a target="_blank" :href="'https://innotech.atlassian.net/browse/' + detail.prevTicket">{{ detail.prevTicket }}</a>
                      →
                      <a target="_blank" :href="'https://innotech.atlassian.net/browse/' + detail.currTicket">{{ detail.currTicket }}</a>
                    </span>
                  </div>
              </div>
              <br v-if="auditLog.changeType === 'update'">
              </div>
              <div v-if="auditLog.delta[1]" >
                <div class="ticket">
                  <a target="_blank" :href="'https://innotech.atlassian.net/browse/' + auditLog.delta[1]['ticket']">{{ auditLog.delta[1]['ticket'] }}</a>
                </div>
                <div
                  v-for="detail in formatContent(auditLog, index)"
                  :key="`detail-${detail.id}`"
                >
                  <div v-if="detail.new" class="new">
                    {{ `${detail.new}` }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-collapse-wrapper>
      </v-collapse-group>
    </div>
    <footer class="footer">
      <select v-model="selectedPageSize.value" @change="onChange">
        <option v-for="option in paginationOptions" :value="option.value" :key="option.value">
          {{ option.name }}
        </option>
      </select>
      <span style="display: inline-block; margin-left: 25px;">
        共 {{ showingRecords }}/{{ totalCount }} 條記錄
      </span>
      <button type="button" class="nextPage" @click="goToNextPage">&#8594;</button>
      <span class="pages">
        {{ pageNum }}/{{ totalPages }}
      </span>
      <button type="button" class="prevPage" @click="goToPrevPage">&#8592;</button>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { convertChangeTypeToUpdateType } from '../../utils/change-type'
import dayjs from "dayjs";

export default {
  name: 'HistorySearch',
  data() {
    return {
      selected: '全部',
      key: '',
      updateUser: '',
      options: [
        '全部',
        '新增',
        '更新翻譯',
        '更新單號',
        '上版',
        '審核',
        // '刪除'
      ],
      selectedPageSize: {
        name:'10 條顯示列數', value: 10
      },
      paginationOptions: [
        {
          name: '10 條顯示列數', value: 10
        },
        {
          name: '25 條顯示列數', value: 25
        },
        {
          name:'50 條顯示列數', value: 50
        },
        {
          name:'100 條顯示列數', value: 100
        }
      ],
      pageNum: 1,
      pageSize: 10,
      totalPages: 1,
      totalCount: 1,
      showingRecords: 1
    }
  },
  computed: {
    ...mapGetters(['historyPageData', 'historyData', 'langs', 'project']),
  },
  methods: {
    dayjs,
    search() {
      this.pageNum = 1
      const payload = this.getPayload()
      this.$store.dispatch("getHistory", payload)
    },
    getPayload(){
      let payload = {}
      if (this.key) payload['key'] = this.key
      if (this.updateUser) payload['updateUser'] = this.updateUser
      if (this.selected !== '全部') payload['updateType'] = this.selected
      payload.pageSize = this.pageSize
      payload.pageNum = this.pageNum
      return payload
    },
    handleSearchChange() {
      this.$store.commit('setHistoryData', [])
      this.$store.commit('setHistoryPageData', {})
    },
    getDiffContent(auditLog) {
      return this.langs.map(d => {
        if (auditLog.delta[0]?.[d] !== auditLog.delta[1]?.[d]) {
          return {
            old: `${d}： ${auditLog.delta[0]?.[d] ?? ''}`,
            new: `${d}： ${auditLog.delta[1]?.[d] ?? ''}`,
            id: `diff-${auditLog._id}-${d}`
          }
        }
      }).filter(Boolean)
    },
    formatContent(auditLog, idx) {
      if (auditLog.changeType === 'create') {
         return this.langs.map(d => {
          if (auditLog.delta[1][d] !== "" && auditLog.delta[1][d] !== undefined) {
            return {
              new: `${d}： ${auditLog.delta[1][d] || ''}`,
              id: `diff-${auditLog._id}-${d}`
            }
          }
          return null
        }).filter(Boolean)
      }

      if (auditLog.changeType === 'delete') {
         return this.langs.map(d => {
          return {
            old: `${d}： ${auditLog.delta[0][d]}`,
            id: `diff-${auditLog._id}-${d}`
          }
        })
      }

      if (auditLog.changeType === 'approve') {
        return [{
          approve: `版本更動:`,
          prevVer: `${auditLog.delta[0]}`,
          currVer: `${auditLog.delta[1]}`,
          id: `diff-${auditLog._id}`
        }]
      }

      if (auditLog.changeType === 'review') {
          return [{
            reviewedTickets: `review ticket: ${auditLog.reviewedTickets}`,
            reviewedVersion: `review version: ${auditLog.reviewedVersion}`,
            id: `diff-${auditLog._id}`
          }]
      }

      if (auditLog.changeType === 'update-ticket') {
          return [{
            updateTicket: `單號更動:`,
            prevTicket: `${auditLog.delta[0]}`,
            currTicket: `${auditLog.delta[1]}`,
            id: `diff-${auditLog._id}`
          }]
      }

      return this.getDiffContent(auditLog, idx)
    },
    convertChangeTypeToUpdateType,
    handleClickSelectAndCopy(e) {
        // IE
        if (document.body.createTextRange) {
            const range = document.body.createTextRange()
            range.moveToElementText(e.target)
            range.select()
        } else if (window.getSelection) {
            const selection = window.getSelection()
            const range = document.createRange()
            range.selectNodeContents(e.target)
            selection.removeAllRanges()
            selection.addRange(range)
        }
        document.execCommand("copy")
        this.$store.dispatch('handleMessage', {
            success: true,
            text: '已複製到剪貼簿'
        })
    },
    goToPrevPage() {
      if (this.pageNum > 1) {
        this.pageNum -= 1
        this.$store.dispatch("getHistory", this.getPayload())
      }
    },
    goToNextPage() {
      if (this.pageNum < this.totalPages) {
        this.pageNum += 1
        this.$store.dispatch("getHistory", this.getPayload())
      }
    },
    onChange() {
      this.pageSize = this.selectedPageSize.value
      this.pageNum = 1
      const payload = this.getPayload()
      this.$store.dispatch("getHistory", payload)
    },
  },
  watch: {
    // key() {
    //   this.handleSearchChange()
    // },
    // updateUser() {
    //   this.handleSearchChange()
    // },
    // selected() {
    //   this.handleSearchChange()
    // }
    project() {
      this.selected = '全部'
      this.key = ''
      this.updateUser = ''
      this.pageNum = 1
      this.search()
    }
  },
  created() {
    this.search()
  },
  beforeUpdate() {
    this.totalCount = this.historyPageData.totalCount
    this.showingRecords = this.historyData.length
    this.totalPages = this.historyPageData.totalPages === 0 ? 1 : this.historyPageData.totalPages
  },
}
</script>
<style lang="scss">
.v-collapse-toggler {
  margin: 5px 0;
  padding: 5px 10px;
  border: 1px solid #cccccc;
  border-radius: 5px;
  display: flex;
  cursor: pointer;
  &:hover {
    background: #eeeeee;
  }
}
.v-collapse-content {
  max-height: 0;
  transition: max-height 0.3s ease-out;
  overflow: hidden;
}
.v-collapse-content-end {
  transition: max-height 0.3s ease-in;
  max-height: inherit;
}
</style>
<style lang="scss" scoped>
.filter-row {
  label {
    margin: 0 5px;
  }
  input {
    margin-right: 5px;
  }
  button {
    margin: 0 10px;
  }
}
button:hover {
  cursor: pointer;
}
.history-content {
  margin: 10px 0;
  .header-row {
    margin: 5px 0;
    padding: 5px 10px;
    // border: 1px solid #cccccc;
    border-radius: 5px;
    display: flex;
    background: #eeeeee;
    > div {
      margin: 0 5px;
      padding: 3px;
      font-size: 20px;
      &.header-type {
        width: 100px;
      }
      &.header-user {
        width: 240px;
        padding-left: 20px;
      }
      &.header-time {
        width: 200px;
      }
    }
  }
}

.collapse-row {
  // color: #fff;
  margin: 0 5px;
  padding: 3px;
  font-size: 16px;
  border-radius: 5px;
  &.update-type {
    width: 90px;
  }
  &.update-user {
    width: 240px;
    padding-left: 30px;
  }
  &.timestamp {
    width: 200px;
    padding-left: 12px;
  }
}
.collapse-child {
  border: 1px solid #cccccc;
  border-radius: 5px;
  padding: 5px 18px;
  padding-bottom: 10px;
  .old {
    background: #cb9898;
  }

  .new {
    background: #d4ffb2;
  }
}

.footer {
  position: fixed;
  bottom: 0;
  padding: 10px 10px;
  width: 93.55%;
  background: #eeeeee;
}

.pages {
  float: right;
  margin-right: 10px;
  border: 1px solid #eeeeee;
  padding: 3px;
  padding-left: 50px;
  padding-right: 50px;
  background-color: white;
}

.prevPage {
  float: right;
  margin-right: 10px;
  margin-top: 1px;
}

.nextPage {
  float: right;
  margin-right: 10px;
  margin-top: 1px;
}

.ticket {
  text-decoration: underline;
  margin-bottom: 5px;
}

.audit-log-key {
  font-size: 16px;
  margin-top: 5px;
  margin-bottom: 5px;
  font-weight: bold;
}

</style>
